import { useEffect } from 'react';
import { userManager } from './oidcConfig';

/**
 * Silent authentication renewal component
 * This component is loaded in a hidden iframe to silently renew access tokens
 * without disrupting the user experience
 */
export const AuthSilentRenew = () => {
  useEffect(() => {
    userManager
      .signinSilentCallback()
      .then(() => {
        console.info('DIAG: Silent token renewal successful');
      })
      .catch(error => {
        console.error('DIAG: Silent token renewal failed', error);
      });
  }, []);

  return null;
};
